const Testimonials = [
  {
    title: 'Very impressed',
    avatarUrl: 'donald-pernsley.png',
    personName: 'Donald Pernsley',
    stars: '5',
    role: 'Don P Insurance',
    testimonialContent:
      'I can’t thank VuSocial enough for spending all that time with me helping me get everything set up absolutely amazing. Very impressed. I will highly recommend you to everyone.',
  },
  {
    title: 'Made me Look Like a Pro!',
    avatarUrl: 'michael-nassif.png',
    personName: 'Michael Nassif',
    stars: '5',
    role: 'Modern Era Insurance',
    testimonialContent:
      'VuSocial did a great job helping me look like a pro, they took time to explain and helped me answer the questions I had. Thanks!',
  },
  {
    title: 'VuSocial did a fantastic job!',
    avatarUrl: 'charlene-cox.png',
    personName: 'Charlene Cox',
    stars: '5',
    role: 'Prospective Insurance',
    testimonialContent:
      'VuSocial did a fantastic job! They were really helpful in showing me around and helping me get the most out of the platform.',
  },
  {
    title: 'Sounds Great!',
    avatarUrl: 'ugo-okwoli.png',
    personName: 'Ugo Okwoli',
    stars: '5',
    role: 'Experior Financial Group',
    testimonialContent: (
      <>
        VuSocial are highly professional and patiently worked me through the
        details. Very helpful, happy with the results.
        <br />
        Thanks much!
      </>
    ),
  },
  {
    title: 'Patient and Knowledgeable',
    avatarUrl: 'pat-pitchford.png',
    personName: 'Pat Pitchford',
    stars: '5',
    role: 'Pitchford & Associates',
    testimonialContent:
      'The VuSocial team was patient and knowledgeable, helping me get started and use the platform to look my best online.',
  },
  {
    title: 'Highly Recommended',
    avatarUrl: 'jean-etienne.png',
    personName: 'Jean Etienne',
    stars: '5',
    role: 'Vanguard Insurance & Financial Services,LLC',
    testimonialContent:
      'VuSocial is great to work with, knowledgeable, professional, and highly recommended',
  },
  {
    title: 'Just How I Like it.',
    avatarUrl: 'marie-janelle.png',
    personName: 'Marie Janelle Pike',
    stars: '5',
    role: 'Marie Janelle Pike DBA',
    testimonialContent: 'Quick easy and a breeze just how I like it.',
  },
  {
    title: 'Informative and Solution Based',
    avatarUrl: 'raymond-ingram.png',
    personName: 'Raymond Ingram',
    stars: '5',
    role: 'Ingrams Financial Group',
    testimonialContent:
      'My experience with VuSocial was very professional and straight to the point informative and solution based. I appreciate this young man in VuSocial support for exemplifying his professionalism and care and helping me to make sure that my business will be successful',
  },
  {
    title: 'Excellent Support!',
    avatarUrl: 'sima-mirzaaghaee.png',
    personName: 'Sima Mirzaaghaee',
    stars: '5',
    role: 'Dual Shields Financial',
    testimonialContent:
      'I had my 1st meeting with VuSocial support today. It was fast, quick, and support has excellent knowledge about VuSocial. They answered all my questions and connected all my social media accounts to VuSocial. Thank you.',
  },
  {
    title: 'Awesome job!',
    avatarUrl: 'mary-wilson-smith.png',
    personName: 'Mary Wilson-Smith',
    stars: '5',
    role: 'Mary Money Moves',
    testimonialContent:
      'VuSocial support is very knowledgeable about the products. Awesome job!!',
  },
];

export default Testimonials;
